export default __webpack_public_path__ + "static/media/prepared_expert.c8373b39.svg";